const data = {
    "frontendList":[
        {
            "name":"React",
            "level":3,
        },
        {
            "name":"Next",
            "level":2,
        },
        {
            "name":"Vue",
            "level":2,
        },
        {
            "name":"TS",
            "level":2,
        },
    ],
    "backendList":[
        {
            "name":"Golang",
            "level":4,
        },
        {
            "name":"Python",
            "level":4,
        },
        {
            "name":"Fast",
            "level":4,
        },
        {
            "name":"Flask",
            "level":3,
        },
        {
            "name":"Django",
            "level":2,
        },
        {
            "name":"Java",
            "level":2,
        },
        {
            "name":"Node",
            "level":2,
        },
    ],
    "infraList":[
        {
            "name":"PostgreSQL",
            "level":4,
        },
        {
            "name":"Docker",
            "level":3,
        },
        {
            "name":"DWH",
            "level":3,
        },
        {
            "name":"Datadog",
            "level":3,
        },
        {
            "name":"Sentry",
            "level":3,
        },
        {
            "name":"k8s",
            "level":2,
        },
        {
            "name":"GCP",
            "level":3,
        },
        {
            "name":"AWS",
            "level":2,
        },
        {
            "name":"Azure",
            "level":2,
        },
        {
            "name":"Redis",
            "level":2,
        },
    ],
    "otherList":[
        {
            "name":"microservice",
            "level":3,
        },
        {
            "name":"C",
            "level":3,
        },
        {
            "name":"DDD",
            "level":3,
        },
        {
            "name":"競プロ",
            "level":3,
        },
    ],
}

export default data;